module.exports = [{
      plugin: require('E:/Akii/Projects git-hub/portfolio/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
